// 土壤监测
const soilUrl = "/business/jgSoilInfo/";
// 虫情
const insectUrl = "/business/jgInsectInfo/";
// 水质
const waterUrl = "/business/jgWaterQualityInfo/";
// 空气
const weatherUrl = "/business/jgWeatherInfo/";
// 水表
const waterInfoUrl = "/business/jgWaterInfo/";
// 电表
const circuitUrl = "/business/jgCircuitBreakerInfo/";
// 监控
const videoUrl = "/business/jgCameraDemoInfo/";
// 垃圾桶
const transhUrl = "/business/jgTrashcanInfo/";
// 割草机
const mowingUrl = "/business/jgMowingInfo/";
// 喷灌
const irrigationUrl = "/business/jgIrrigationDevice/";
// 设备管理
const deviceUrl = "/business/jgDeviceAllot/";
// 设备统计
const deviceStatsic = "/business/jgDeviceStats/";
// 工牌手环
const workInfo = "/business/jgWorkerInfo/";
const waterInfo = "/business/jgWaterLyInfo/";
const wsInfo = "/business/jgSprayInfo/";
const wsPlan = "/business/jgSprayPlan/";
const api = {
  selectDeviceAllotByPage: deviceUrl + "selectDeviceAllotByPage",
  selectDeviceOnlineStats: deviceStatsic + "selectDeviceOnlineStats",

  selectSoilInfoByPage: soilUrl + "selectJgSoilInfoByPage",
  updateSoilInfo: soilUrl + "updateSoilInfo",
  selectProjectSoilByList: soilUrl + "selectProjectSoilByList",
  selectSoilInfoByDeviceNumber: soilUrl + "selectSoilInfoByDeviceNumber",
  updateSoilInfoConf: soilUrl + "updateSoilInfoConf",
  updateSoilInfoLocation: soilUrl + "updateSoilInfoLocation",
  // 分页查询土壤监测历史数据
  selectSoilDataByPage: soilUrl + "selectJgSoilDataByPage",
  selectSoilWarningByPage: soilUrl + "selectSoilWarningByPage",

  selectInsectInfoByPage: insectUrl + "selectInsectInfoByPage",
  updateInsectInfo: insectUrl + "updateInsectInfo",
  selectInsectInfoByDeviceNumber: insectUrl + "selectInsectInfoByDeviceNumber",
  updateInsectInfoLocation: insectUrl + "updateInsectInfoLocation",
  selectProjectInsectByList: insectUrl + "selectProjectInsectByList",
  selectInsectImgByPage: insectUrl + "selectInsectImgByPage",
  selectInsectDataByPage: insectUrl + "selectInsectDataByPage",

  selectWaterQualityInfoByPage: waterUrl + "selectWaterQualityInfoByPage",
  updateWaterQualityInfo: waterUrl + "updateWaterQualityInfo",
  selectWaterQualityInfoByDeviceNumber:
    waterUrl + "selectWaterQualityInfoByDeviceNumber",
  updateWaterQualityInfoLocation: waterUrl + "updateWaterQualityInfoLocation",
  selectProjectWaterQualityByList: waterUrl + "selectProjectWaterQualityByList",
  selectWaterQualityDataByPage: waterUrl + "selectWaterQualityDataByPage",

  selectWeatherInfoByPage: weatherUrl + "selectWeatherInfoByPage",
  updateWeatherInfo: weatherUrl + "updateWeatherInfo",
  selectWeatherInfoByDeviceNumber:
    weatherUrl + "selectWeatherInfoByDeviceNumber",
  updateWeatherInfoLocation: weatherUrl + "updateWeatherInfoLocation",
  selectProjectWeatherByList: weatherUrl + "selectProjectWeatherByList",
  selectWeatherDataByPage: weatherUrl + "selectWeatherDataByPage",

  // 水表
  // 批量分配水表
  updateWaterInfo: waterInfoUrl + "updateWaterInfo",
  // 智慧水表打点和修改名称
  updateWaterInfoLocation: waterInfoUrl + "updateWaterInfoLocation",
  // 查询智慧水表详情
  selectWaterInfoByDeviceNumber: waterInfoUrl + "selectWaterInfoByDeviceNumber",
  // 分页查询智慧水表列表
  selectWaterInfoByPage: waterInfoUrl + "selectWaterInfoByPage",
  // 分页查询智慧水表历史数据
  selectWaterDataByPage: waterInfoUrl + "selectWaterDataByPage",
  // 智慧水updateCameraDemoData表统计
  selectWaterStatistic: waterInfoUrl + "selectWaterStatistic",
  // 分页查询智慧水表折线图
  selectWaterMap: waterInfoUrl + "selectWaterMap",

  // 电表
  // 批量分配智慧断路器
  updateJgCircuitBreakerInfo: circuitUrl + "updateJgCircuitBreakerInfo",
  // 智慧断路器打点和修改名称
  updateJgCircuitBreakerInfoLocation:
    circuitUrl + "updateJgCircuitBreakerInfoLocation",
  // 查询智慧断路器详情
  selectJgCircuitBreakerInfoByDeviceNumber:
    circuitUrl + "selectJgCircuitBreakerInfoByDeviceNumber",
  // 分页查询智慧断路器列表
  selectJgCircuitBreakerInfoByPage:
    circuitUrl + "selectJgCircuitBreakerInfoByPage",
  // 查询智慧断路器历史数据
  selectJgCircuitBreakerDataByPage:
    circuitUrl + "selectJgCircuitBreakerDataByPage",
  // 监控
  // 新增智慧监控
  insertCameraDemoInfo: videoUrl + "insertCameraDemoInfo",
  // 修改智慧监控
  updateCameraDemoData: videoUrl + "updateCameraDemoData",
  // 批量分配智慧监控
  updateCameraDemoInfo: videoUrl + "updateCameraDemoInfo",
  // 智慧监控打点
  updateCameraDemoInfoLocation: videoUrl + "updateCameraDemoInfoLocation",
  // 查询智慧智慧监控详情
  selectCameraDemoInfoByDeviceNumber:
    videoUrl + "selectCameraDemoInfoByDeviceNumber",
  // 分页查询智慧智慧监控列表
  selectCameraDemoInfoByPage: videoUrl + "selectCameraDemoInfoByPage",
  // 垃圾桶
  // 批量分配垃圾桶
  updateTrashcanInfo: transhUrl + "updateTrashcanInfo",
  // 垃圾桶打点和修改名称
  updateTrashcanInfoLocation: transhUrl + "updateTrashcanInfoLocation",
  // 查询智慧垃圾桶详情
  selectTrashcanInfoByDeviceNumber:
    transhUrl + "selectTrashcanInfoByDeviceNumber",
  // 分页查询智慧垃圾桶列表
  selectTrashcanInfoByPage: transhUrl + "selectTrashcanInfoByPage",
  // 分页查询智慧垃圾桶历史数据
  selectTrashcanDataByPage: transhUrl + "selectTrashcanDataByPage",
  // 喷灌
  // 批量分配喷灌
  updateJgIrrigationValveProject:
    irrigationUrl + "updateJgIrrigationValveProject",
  // 喷灌打点和修改名称
  updateJgIrrigationValveLocation:
    irrigationUrl + "updateJgIrrigationValveLocation",
  // 查询喷灌详情
  selectJgIrrigationValveByDeviceNumber:
    irrigationUrl + "selectJgIrrigationValveByDeviceNumber",
  // 分页查询喷灌列表
  selectJgIrrigationValveByPage:
    irrigationUrl + "selectJgIrrigationValveByPage",
  // 分页查询喷灌历史数据
  selectJgIrrigationValveRecordByPage:
    irrigationUrl + "selectJgIrrigationValveRecordByPage",
  // 割草机
  // 批量分配割草机
  updateMowingInfo: mowingUrl + "updateMowingInfo",
  // 割草机打点和修改名称
  updateMowingInfoLocation: mowingUrl + "updateMowingInfoLocation",
  // 查询割草机详情
  selectJgMowingInfoByDeviceNumber:
    mowingUrl + "selectJgMowingInfoByDeviceNumber",
  // 分页查询割草机列表
  selectMowingInfoByPage: mowingUrl + "selectMowingInfoByPage",
  // 分页查询割草机历史数据
  selectMowingDataByList: mowingUrl + "selectMowingDataByList",
  // 工牌手环
  // 批量分配工牌手环
  updateWorkerInfoProject: workInfo + "updateWorkerInfoProject",
  // 工牌手环修改名称
  updateWorkerInfoName: workInfo + "updateWorkerInfoName",
  // 查询工牌手环详情
  selectWorkerInfoByDeviceNumber: workInfo + "selectWorkerInfoByDeviceNumber",
  // 分页查询工牌手环列表
  selectYhWorkerDeviceByList: workInfo + "selectYhWorkerDeviceByList",
  selectWorkerTrajectoryList: workInfo + "selectWorkerTrajectoryList",
  // 流压监测

  // 批量分配流压监测
  updateWaterLyInfo: waterInfo + "updateWaterLyInfo",
  // 流压监测打点和修改名称
  updateWaterLyInfoLocation: waterInfo + "updateWaterLyInfoLocation",
  // 查询流压监测详情
  selectWaterLyInfoByDeviceNumber:
    waterInfo + "selectWaterLyInfoByDeviceNumber",
  // 分页查询流压监测列表
  selectWaterLyInfoByPage: waterInfo + "selectWaterLyInfoByPage",
  // 分页查询流压监测历史数据
  selectWaterLyDataByPage: waterInfo + "selectWaterLyDataByPage",
  updateJgWaterLyInfoThreshold: waterInfo + "updateJgWaterLyInfoThreshold",

  // 批量分配雾森
  updateJgSprayInfo: wsInfo + "updateJgSprayInfo",
  // 雾森打点和修改名称
  updateJgSprayInfoLocation: wsInfo + "updateJgSprayInfoLocation",
  // 查询雾森监测详情
  selectJgSprayInfoByDeviceNumber: wsInfo + "selectJgSprayInfoByDeviceNumber",
  // 分页查询雾森监测列表
  selectJgSprayInfoByPage: wsInfo + "selectJgSprayInfoByPage",
  // 分页查询雾森监测历史数据
  selectJgSprayDataByPage: wsInfo + "selectJgSprayDataByPage",
  updateJgSprayInfoRecord: wsInfo + "updateJgSprayInfoRecord",
  selectProjectJgSprayByList: wsInfo + "selectProjectJgSprayByList",

  // 新增雾森计划
  insertJgSprayPlan: wsPlan + "insertJgSprayPlan",
  // 修改雾森计划
  updateJgSprayPlan: wsPlan + "updateJgSprayPlan",
  // 删除雾森计划
  deleteJgSprayPlan: wsPlan + "deleteJgSprayPlan",
  // 启用/禁用雾森计划
  updateJgSprayPlanStatus: wsPlan + "updateJgSprayPlanStatus",
  // 分页查询雾森计划列表
  selectJgSprayPlanByPage: wsPlan + "selectJgSprayPlanByPage",
  // 查询雾森计划详情
  selectJgSprayPlanByPlanId: wsPlan + "selectJgSprayPlanByPlanId",
  // 分页查询雾森计划历史数据
  selectJgSprayPlanRecordByPage: wsPlan + "selectJgSprayPlanRecordByPage",

};
export default api;
